import {
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  ADD_DEPARTMENTS,
  ADD_DEPARTMENTS_SUCCESS,
  ADD_DEPARTMENTS_FAIL,
  UPDATE_DEPARTMENTS,
  UPDATE_DEPARTMENTS_SUCCESS,
  UPDATE_DEPARTMENTS_FAIL,
  DELETE_DEPARTMENTS,
  DELETE_DEPARTMENTS_SUCCESS,
  DELETE_DEPARTMENTS_FAIL,
  SET_DEPARTMENT_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  departments: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DEPARTMENTS:
      return { ...state, loading: true }
    case GET_DEPARTMENTS_SUCCESS:
      return { ...state, loading: false, departments: action.payload }
    case GET_DEPARTMENTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_DEPARTMENTS:
      return { ...state, loading: true }
    case ADD_DEPARTMENTS_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} } // Clear field errors on success
    case ADD_DEPARTMENTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_DEPARTMENTS:
      return { ...state, loading: true }
    case UPDATE_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_DEPARTMENTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_DEPARTMENTS:
      return { ...state, loading: true }
    case DELETE_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_DEPARTMENTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_DEPARTMENT_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default departmentReducer
